import { SizeValidatorConfig, ValdrValidator } from '@app/valdr/models';
import { stringLengthValidator } from '@app/valdr/validators/length-validator';
import * as R from 'ramda';

export const sizeValidator: ValdrValidator = R.curry(({min = 0, max = +Infinity}: SizeValidatorConfig, value: any) => {
  const isGreaterThanMin = stringLengthValidator(R.lte(min));
  const isLessThanMax = stringLengthValidator(R.gte(max));
  const isBetweenMinAndMax = R.allPass([isGreaterThanMin, isLessThanMax]);

  return isBetweenMinAndMax(value);
});
